"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'template-a[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -780,
        'y': -2215,
        'width': 405,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -780,
        'y': -2137,
        'width': 405,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -780,
        'y': -2082,
        'width': 405,
        'height': 63
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-a[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 72,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 645,
        'y': -2217,
        'width': 269,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 645,
        'y': -2157,
        'width': 269,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 645,
        'y': -2106,
        'width': 269,
        'height': 105
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-a[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 72,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1559,
        'y': -2092,
        'width': 269,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1559,
        'y': -2032,
        'width': 269,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1559,
        'y': -1981,
        'width': 269,
        'height': 105
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-b[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -882,
        'y': -890,
        'width': 480,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -882,
        'y': -812,
        'width': 480,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -882,
        'y': -757,
        'width': 480,
        'height': 63
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-b[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 72,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 618,
        'y': -882,
        'width': 324,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 618,
        'y': -822,
        'width': 324,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 618,
        'y': -771,
        'width': 324,
        'height': 84
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-b[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 72,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1530,
        'y': -737,
        'width': 327,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1530,
        'y': -677,
        'width': 327,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1530,
        'y': -626,
        'width': 327,
        'height': 84
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  }
};
exports.default = _default;